import { render, staticRenderFns } from "./PopoverNotification.vue?vue&type=template&id=36fce04c&scoped=true"
import script from "./PopoverNotification.vue?vue&type=script&lang=js"
export * from "./PopoverNotification.vue?vue&type=script&lang=js"
import style0 from "./PopoverNotification.vue?vue&type=style&index=0&id=36fce04c&prod&lang=stylus&scoped=true"
import style1 from "./PopoverNotification.vue?vue&type=style&index=1&id=36fce04c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fce04c",
  null
  
)

export default component.exports